import React from 'react';

const SvgAm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AM_svg__b" fill="#fff">
        <use xlinkHref="#AM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AM_svg__a" />
      <path fill="#1047B9" mask="url(#AM_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#F01C31" mask="url(#AM_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#FECB2F" mask="url(#AM_svg__b)" d="M0 13.333h28V20H0z" />
    </g>
  </svg>
);

export default SvgAm;
